import React from 'react';
import CommonSVGIcon, { Props } from '@/components/icons/CommonSVGIcon';

export default function (props: Props) {
  return (
    <CommonSVGIcon {...props} viewBox="0 0 18 18">
      <path d="M9 0.666992C13.6 0.666992 17.333 4.4 17.333 9C17.333 13.6 13.6 17.333 9 17.333C4.4 17.333 0.666992 13.6 0.666992 9C0.666992 4.4 4.4 0.666992 9 0.666992ZM9 2.33301C5.325 2.33301 2.33301 5.325 2.33301 9C2.33301 12.675 5.325 15.667 9 15.667C12.675 15.667 15.667 12.675 15.667 9C15.667 5.325 12.675 2.33301 9 2.33301ZM12.7334 6.8418L10.375 9.2002L12.7334 11.5586L11.5586 12.7334L9.2002 10.375L6.8418 12.7334L5.66699 11.5586L8.02539 9.2002L5.66699 6.8418L6.8418 5.66699L9.2002 8.02539L11.5586 5.66699L12.7334 6.8418Z"/>
    </CommonSVGIcon>
  );
}
